import { gql } from "graphql-tag"

const techSpec = gql`
  type TechSpec {
    category: String!
    id: ID!
    name: String!
    subCategory: String!
  }
`

export default techSpec
